import { render, staticRenderFns } from "./ContainerPersonContact.vue?vue&type=template&id=96e611e8"
import script from "./ContainerPersonContact.vue?vue&type=script&lang=js"
export * from "./ContainerPersonContact.vue?vue&type=script&lang=js"
import style0 from "./ContainerPersonContact.vue?vue&type=style&index=0&id=96e611e8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports